import { useMutation } from "@tanstack/react-query";
import api from "@services/api";

export function useNotificationPreviewMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post(`/notifications/preview`, payload);
      return data;
    }
  });
}

export function useNotificationSendMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post(`/notifications/send`, payload);
      return data;
    }
  });
}

